import Section from './Section';
import SectionFromInstanceConfig from './SectionFromInstanceConfig';
import SkuLine from './SkuLine';

export default function createMergedAndRankedSectionData(
    sectionsFromInstanceConfig: SectionFromInstanceConfig[],
    sectionLabelForUnRankedProducts: string,
    skusInCategory: SkuLine[]
): Section[] {
    const newSections = [];
    let skusToCategorize = [];
    skusInCategory.forEach((skuFromServer) => {
        skusToCategorize.push(skuFromServerToSkuLine(skuFromServer));
    });
    sectionsFromInstanceConfig.forEach((section) => {
        const skusInThisSection = [];
        const skusNotInThisSection = [];
        skusToCategorize.forEach((skuToCategorize) => {
            if (section.rankedSkus && section.rankedSkus.includes(skuToCategorize.skuNumber)) {
                skusInThisSection[section.rankedSkus.indexOf(skuToCategorize.skuNumber)] = (skuToCategorize);
            } else {
                skusNotInThisSection.push(skuToCategorize);
            }
        });
        skusToCategorize = skusNotInThisSection;
        newSections.push({
            label: section.label,
            persistent: true,
            skuLines: skusInThisSection.filter((item) => item !== undefined), // Filter removes empty keys
        });
    });
    if (skusToCategorize.length !== 0) {
        newSections.push({
            label: sectionLabelForUnRankedProducts,
            persistent: false,
            skuLines: skusToCategorize, // Contains left over skus that were not in any section
        });
    }
    return newSections;
}

function skuFromServerToSkuLine(skuFromServer: SkuLine): SkuLine {
    return {
        bv: skuFromServer.price,
        data: skuFromServer.data,
        detailPageUrl: skuFromServer.detailPageUrl,
        formattedBv: skuFromServer.formattedBv,
        formattedPrice: skuFromServer.formattedPrice,
        formattedPv: skuFromServer.formattedPv,
        mainImage: skuFromServer.mainImage,
        name: skuFromServer.name,
        price: skuFromServer.price,
        pv: skuFromServer.price,
        skuNumber: skuFromServer.skuNumber,
        url: skuFromServer.url,
    };
}
